import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Loader2 } from 'lucide-react';
import Landing from '@/pages/Landing';
import Dashboard from '@/pages/Dashboard';
import AppShell from '@/components/layout/AppShell';

/**
 * RootGate
 * Public-friendly entry for "/".
 * - If user is authenticated → render Dashboard inside the AppShell.
 * - If not authenticated → render the public Landing page (no shell, no sidebar).
 * - While auth is being verified → show a quiet loader to avoid a blank screen.
 */
export default function RootGate() {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-3">
          <Loader2 className="h-7 w-7 animate-spin text-primary" />
          <span className="text-sm text-muted-foreground">Laster...</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Landing />;
  }

  return (
    <AppShell>
      <Dashboard />
    </AppShell>
  );
}
